export enum WorkplaceStatusPersonRelation {
    NOT_RELATED = 'NOT_RELATED',
    WORKER_NOT_PRESENT = 'WORKER_NOT_PRESENT',
    WORKER_PRESENT = 'WORKER_PRESENT'
}
